import gql from 'graphql-tag';

export const GET_TIMESHEETS_AWAITING_APPROVAL = gql`
  query ($ownedBy: JobOwnerEnum, $country: String, $first: Int, $after: String) {
    weployer {
      timesheetsAwaitingApproval(ownedBy: $ownedBy, country: $country, first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          firstEntryDate
          lastEntryDate
          submittedAt
          rejectionReason
          rejectionState
          job {
            title
            owner
            belongsToCurrentUser
            startTime
            finishTime
            timezone
          }
          weployee {
            contactDetails {
              name
            }
            profileImageUrl
          }
          invoice {
            baseHourlyRate
            creditSurchargeFee
            ordinaryHours
            ordinaryWages
            payrollComplianceFee
            penaltyHours
            penaltyWages
            serviceFee
            subtotalGst
            subtotal
            currency
          }
          payslipItems {
            startTime,
            finishTime,
            totalHours,
          }
          timesheetEntries {
            breakMinutes
            finishTime
            startTime
            totalMinutes
            timesheetBreaks {
              finishTime
              startTime
            }
          }
        }
      }
    }
  }
`;

export const GET_LOCATION_COUNTRIES = gql`
  query {
    weployer {
      locationCountries
    }
  }
`;

export const GET_APPROVED_TIMESHEETS = gql`
  query ($ownedBy: JobOwnerEnum, $first: Int, $after: String) {
    weployer{
      approvedTimesheets(ownedBy: $ownedBy, first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          firstEntryDate
          lastEntryDate
          submittedAt
          approvedAt
          approvedBy
          job {
            title
            owner
            belongsToCurrentUser
            startTime
            finishTime
            timezone
          }
          weployee {
            contactDetails {
              name
            }
            profileImageUrl
          }
          invoice {
            baseHourlyRate
            creditSurchargeFee
            ordinaryHours
            ordinaryWages
            payrollComplianceFee
            penaltyHours
            penaltyWages
            serviceFee
            subtotalGst
            subtotal
            currency
          }
          payslipItems {
            startTime,
            finishTime,
            totalHours,
          }
          timesheetEntries {
            breakMinutes
            finishTime
            startTime
            totalMinutes
            timesheetBreaks {
              finishTime
              startTime
            }
          }
        }
      }
    }
  }
`;

export const GET_TIMESHEET_BY_ID = gql`
  query ($id: ID!) {
    weployer {
      timesheet(id: $id) {
        id
        firstEntryDate
        lastEntryDate
        submittedAt
        approvedAt
        approvedBy
        rejectionReason
        rejectionState
        job {
          title
          owner
          belongsToCurrentUser
          startTime
          finishTime
          timezone
          location {
            country
          }
        }
        weployee {
          contactDetails {
            name
          }
          profileImageUrl
        }
        invoice {
          baseHourlyRate
          creditSurchargeFee
          ordinaryHours
          ordinaryWages
          payrollComplianceFee
          penaltyHours
          penaltyWages
          serviceFee
          subtotalGst
          subtotal
          currency
        }
        timesheetEntries {
          breakMinutes
          finishTime
          startTime
          totalMinutes
          timesheetBreaks {
            finishTime
            startTime
          }
        }
      }
    }
  }
`;

export const GET_INVOICE_SUMMARIES = gql`
  query($timesheetIds: [String!]!) {
    weployer {
      invoiceSummaries(timesheetIds: $timesheetIds) {
        creditSurchargeFee
        ordinaryHours
        ordinaryWages
        payrollComplianceFee
        penaltyHours
        penaltyWages
        serviceFee
        subtotalGst
        subtotal
        skillId
        skillName
        numberOfTimesheets
        baseHourlyRate
        paymentMethods
        currency
      }
      paymentTerm {
        id
        code
        chargePercentage
        days
      }
      availableCoupons {
        code
        id
        remainingCredit
      }
    }
  }
`;

export const GET_INVOICE_TOTALS = gql`
query($timesheetIds: [String!]!, $paymentTermId: ID, $redeemedCouponId: ID) {
  weployer {
    invoiceTotals(
      timesheetIds: $timesheetIds,
      paymentTermId: $paymentTermId,
      redeemedCouponId: $redeemedCouponId
    ) {
      couponGst
      coupon
      currency
      creditSurchargeFee
      grandTotal
      subtotalGst
      subtotal
    }
  }
}
`;

export const GET_PAYMENT_TERMS = gql`
{
  referenceData {
    paymentTerms {
      id
      code
      chargePercentage
      days
    }
  }
}
`;

export const APPROVE_TIMESHEETS = gql`
  mutation($timesheetIds: [ID!]!, $paymentTermId: ID, $couponCode: String) {
    weployer {
      approveTimesheets(timesheetIds: $timesheetIds, paymentTermId: $paymentTermId, couponCode: $couponCode) {
        timesheetIds
      }
    }
  }
`;

export const timesheetsQueryParams = ({
  ownedBy,
  country,
  first,
  after,
}) => ({
  ownedBy,
  country,
  first,
  after,
});

export const timesheetQueryParams = ({ id }) => ({ id });
